export default __webpack_public_path__ + "static/media/AR.01c82973.jpg";